// components/ReceiptPreview.js

import React from "react";
import logo from "../assets/images/CWA_logo.png";
import { format } from 'date-fns';

const ReceiptPreview = ({ member }) => {
    return (
        <div id="receipt" className="min-h-screen p-6 bg-white text-black">
            <div className="flex justify-between items-center mb-4">
                <img src={logo} alt="Temple Logo" style={{ width: "140px", height: "auto" }} />
                <div className="text-right text-sm">
                    <p>TKS Trust</p>
                    <p>Project Office, Chennai</p>
                    <p>Phone: +91 98418 18740</p>
                    <p>Email: tsct041224@gmail.com</p>
                    <p>Website: www.tkstrust.org</p>
                </div>
            </div>

            <div className="bg-yellow-400 p-2 font-bold text-xl">Payment Receipt</div>

            <div className="text-left mt-4">
                <h2 className="font-bold">Invoice to:</h2>
                <p><strong>Name:</strong> {member.First_Name} {member.Last_Name}</p>
                <p><strong>Address:</strong> {member.City}</p>
                <p>
                    <strong>Date:</strong> {format(new Date(member.Payment_Date), 'dd MMMM yyyy')}
                </p>
                <p><strong>Payment Method:</strong> {member.Payment_Method}</p>
                <p><strong>Payment ID:</strong> {member.Payment_Id}</p>
            </div>

            <hr className="my-4" />

            <h2 className="font-bold mb-2">Products</h2>
            <table className="w-full border text-left">
                <thead>
                    <tr className="bg-blue-100">
                        <th className="p-2">Product</th>
                        <th className="p-2">Validity</th>
                        <th className="p-2">Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className="bg-blue-50">
                        <td className="p-2">Membership</td>
                        <td className="p-2">Lifetime</td>
                        <td className="p-2">₹ 2000</td>
                    </tr>
                </tbody>
            </table>

            <div className="flex justify-end mt-4 bg-yellow-400 p-2 font-bold text-lg">
                <span>Total: ₹ 2000</span>
            </div>

            <p className="text-sm mt-4">
                For any questions, please contact our admin tsct041224@gmail.com or +91 98418 18740.
            </p>
        </div>
    );
};

export default ReceiptPreview;
